'use client';
import styles from './header.module.css';
import { Menu, Portal } from '@chakra-ui/react';
import React, { useState } from 'react';
import useModal from '@/components/modal/use-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import {
	faArrowRightToBracket,
	faEnvelopeOpen,
	faPenToSquare,
	faUser,
	faWrench,
} from '@awesome.me/kit-012d1b9af0/icons/classic/regular';
import NotificationModal from '@/components/modal/notification-modal/notificaton-modal';
import { signOut, useSession } from 'next-auth/react';

export default function UserMenu() {
	const { data: session } = useSession();
	const [open, setOpen] = useState(false);
	const { isOpen, onClose, onOpen } = useModal();

	function notificationHandler() {
		setOpen(false);
		onOpen('notification-modal');
	}

	async function logoutHandler() {
		setOpen(false);
		await signOut();
	}

	return (
		<>
			<Menu.Root open={open} onInteractOutside={() => setOpen(false)}>
				<Menu.Trigger asChild onClick={() => setOpen((prev) => !prev)}>
					<p className={styles.text}>
						Your
						<br />
						<span className={styles.bold}>Account</span>
					</p>
				</Menu.Trigger>
				<Portal>
					<Menu.Positioner>
						<Menu.Content>
							<Menu.Item
								value='sciprofile'
								padding={'0.75rem 1.5rem 0.75rem 0.75rem'}
							>
								<Link
									href={'/sciprofile'}
									className={styles.a}
									onClick={() => setOpen(false)}
								>
									<FontAwesomeIcon icon={faUser} size='lg' color='#777' /> Your
									SCI Profile
								</Link>
							</Menu.Item>

							<Menu.Item
								value='notifications'
								padding={'0.75rem 1.5rem 0.75rem 0.75rem'}
							>
								<button className={styles.a} onClick={notificationHandler}>
									<FontAwesomeIcon
										icon={faEnvelopeOpen}
										size='lg'
										color='#777'
									/>{' '}
									Notification Settings
								</button>
							</Menu.Item>

							<Menu.Item
								value='account'
								padding={'0.75rem 1.5rem 0.75rem 0.75rem'}
							>
								<Link
									href={'/account'}
									className={styles.a}
									onClick={() => setOpen(false)}
								>
									<FontAwesomeIcon icon={faWrench} size='lg' color='#777' />{' '}
									Account Settings
								</Link>
							</Menu.Item>

							{session?.user?.role === 'admin' && (
								<Menu.Item
									value='admin'
									padding={'0.75rem 1.5rem 0.75rem 0.75rem'}
									onClick={() => setOpen(false)}
								>
									<a
										href={process.env.NEXT_PUBLIC_ADMIN_URL}
										target='_blank'
										rel='noopener noreferrer'
										className={styles.a}
									>
										<FontAwesomeIcon
											icon={faPenToSquare}
											size='lg'
											color='#777'
										/>{' '}
										Admin Dashboard
									</a>
								</Menu.Item>
							)}
							<hr />

							<Menu.Item value='/' padding={'0.75rem 1.5rem 0.75rem 0.75rem'}>
								<button className={styles.a} onClick={logoutHandler}>
									<FontAwesomeIcon
										icon={faArrowRightToBracket}
										size='lg'
										color='#777'
									/>{' '}
									Log out
								</button>
							</Menu.Item>
						</Menu.Content>
					</Menu.Positioner>
				</Portal>
			</Menu.Root>

			<NotificationModal
				isOpen={isOpen('notification-modal')}
				onClose={() => onClose('notification-modal')}
			/>
		</>
	);
}
